import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../css/promotiondetails.css";
import { generatePromoPDF } from "../utils/generatePromoPDF";


const PromotionDetails = () => {
  const { id } = useParams();
  const [sales, setSales] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [ticketsToPrint, setTicketsToPrint] = useState(0);
  const [receiptNo, setReceiptNo] = useState("Unknown");
  const [promoName, setPromoName] = useState("Promotion");


const openPrintModal = (count, receipt) => {
  setTicketsToPrint(count);
  setReceiptNo(receipt);
  setShowPrintModal(true);
};

const closePrintModal = () => {
  setShowPrintModal(false);
  setTicketsToPrint(0);
};

const handlePrintTickets = () => {
  setTimeout(() => {
    window.print();
    closePrintModal(); // Optional, close after
  }, 300); // Delay helps render before printing
};


  useEffect(() => {
    fetch(`https://pos-backend-58o9.onrender.com/api/promo-qualifiers/${id}`)
      .then(res => res.json())
      .then(data => {
        setPromoName(data.name || "Promotion");
        setSales(data.qualifiers || []);
      })
      
      .catch(err => console.error("Failed to load qualifiers", err));
  }, [id]);

  const filteredSales = sales.filter(q =>
    q.receipt_no.toLowerCase().includes(search.toLowerCase()) ||
    q.customer_name.toLowerCase().includes(search.toLowerCase()) ||
    q.amount_spent.toString().includes(search)
  );

  const toggleSelect = (receipt) => {
    setSelected(prev =>
      prev.includes(receipt) ? prev.filter(r => r !== receipt) : [...prev, receipt]
    );
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete selected qualifiers?")) return;

    for (const receipt of selected) {
      await fetch(`https://pos-backend-58o9.onrender.com/api/promo-qualifiers/${id}/${receipt}`, {
        method: "DELETE"
      });
    }

    setSales(prev => prev.filter(q => !selected.includes(q.receipt_no)));
    setSelected([]);
  };

  const handlePDFExport = async () => {
    const match = sales.find((s) => s.receipt_no === receiptNo);
  
    const pdfBytes = await generatePromoPDF({
      count: ticketsToPrint,
      receiptNo: receiptNo,
      promoName: promoName,
      customer: {
        name: match?.customer_name || "N/A",
        phone: match?.customer_phone || "N/A",     // Add this only if you store it
        address: match?.customer_address || "N/A", // Same here
      }
    });
  
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
  
    const newWindow = window.open(url);
    if (newWindow) {
      newWindow.focus();
      // Optionally auto-print:
      // setTimeout(() => newWindow.print(), 1000);
    }
  
    closePrintModal();
  };
  

  return (
    <div className="promotion-details-container">
      <h2>🎟️ {promoName}</h2>


      <div className="promo-header-actions">
        <input
          type="text"
          placeholder="Search receipt, customer or amount..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {selected.length > 0 && (
          <button className="delete-btn" onClick={handleDelete}>
            Delete Selected ({selected.length})
          </button>
        )}
      </div>

      <table className="promo-qualifiers-table">
        <thead>
          <tr>
            <th>Select</th>
            <th>Receipt No</th>
            <th>Customer Name</th>
            <th>Amount Spent</th>
            <th>Tickets Earned</th>
          </tr>
        </thead>
        <tbody>
          {filteredSales.map((sale, idx) => (
            <tr key={idx}>
              <td>
                <input
                  type="checkbox"
                  checked={selected.includes(sale.receipt_no)}
                  onChange={() => toggleSelect(sale.receipt_no)}
                />
              </td>
              <td>{sale.receipt_no}</td>
              <td>{sale.customer_name}</td>
              <td>${parseFloat(sale.amount_spent).toFixed(2)}</td>
              <td
  className="clickable-ticket"
  onClick={() => openPrintModal(sale.tickets_earned, sale.receipt_no)}
>
  {sale.tickets_earned}
</td>

            </tr>
          ))}
        </tbody>
        </table>

{showPrintModal && (
  <div className="ticket-modal">
    <div className="ticket-modal-content">
      <h3>🎫 Print Promotion Tickets</h3>
      <p>You earned <strong>{ticketsToPrint}</strong> ticket(s). Would you like to print now?</p>
      <div className="ticket-buttons">
      <button onClick={handlePDFExport}>🖨️ Print</button>

        <button onClick={closePrintModal}>Cancel</button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default PromotionDetails;
